import { queryOptions } from "@tanstack/react-query";

import {
  fetchCurrentVoucherCart,
  fetchVoucherCartCheckout,
  fetchVoucherCartCheckoutVouchers,
} from "./requests";

export const VoucherCartQueries = {
  current: queryOptions({
    queryKey: ["voucherCart", "current"],
    queryFn: fetchCurrentVoucherCart,
  }),

  checkoutSession: (uuid: string) =>
    queryOptions({
      queryKey: ["voucherCart", "checkoutSession", uuid],
      queryFn: () => fetchVoucherCartCheckout(uuid),
    }),

  checkoutSessionVouchers: (voucherCartUuid: string) =>
    queryOptions({
      queryKey: ["voucherCart", "checkoutSessionVouchers", voucherCartUuid],
      queryFn: () => fetchVoucherCartCheckoutVouchers(voucherCartUuid),
    }),
};
